import type {
    GetCommerceCheckoutRequest,
    GetCommerceCheckoutResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const getCommerceCheckoutOperation = defineCommerceOperation<
    GetCommerceCheckoutRequest,
    GetCommerceCheckoutResponse
>("commerce.checkout.get");
